import { observer } from 'mobx-react';
import React from 'react';
import { AnalyticsProvider, Card, CardContent, Grid, GridColumn, Heading, Notice, Separator, Text } from 'telia-front-react';
import LoggedIn from '../sso/LoggedIn';
import { TranslationsContext } from '@teliaee/telia-translate';

export interface CustomerServiceProps {
  heading?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  className?: string;
  translationKey?: string;
  secondaryHeadingTranslationKey?: string;
  children: React.ReactChild | React.ReactChild[] | string;
}

const CustomerService: React.FC<CustomerServiceProps> = (props: CustomerServiceProps) => {
  const { heading, className, translationKey = 'customerService.heading', secondaryHeadingTranslationKey, children } = props;

  const translate = React.useContext(TranslationsContext).translate;

  return (
    <LoggedIn showForDealer={true}>
      <AnalyticsProvider group={'Customer Service'}>
        <Card type={'employee'} background="transparent">
          <CardContent>
            <Text>
              <Grid>
                <GridColumn width={['min-sm']}>
                  <Notice size="small" type="employee" align="center">
                    <Heading element={heading ?? 'h2'} className={className}>
                      {translate(translationKey)}
                    </Heading>
                    {secondaryHeadingTranslationKey && translate(secondaryHeadingTranslationKey)}
                  </Notice>
                </GridColumn>
              </Grid>
              {children}
            </Text>
          </CardContent>
        </Card>
        <Separator spacing={'small'} color={'invisible'} />
      </AnalyticsProvider>
    </LoggedIn>
  );
};

export default observer(CustomerService);
